"use client";

import BrowserActionsInit from "../BrowserActionsInit/BrowserActionsInit";
import ServiceWorkerInit from "../ServiceWorkerInit/ServiceWorkerInit";

type AppStandardsInitProps = {
  browserActions?: boolean;
  serviceWorker?: boolean;
  serviceWorkerUrl?: string;
};

/**
 * Mount once in each app root layout for shared client-side standards.
 */
export default function AppStandardsInit({
  browserActions = true,
  serviceWorker = false,
  serviceWorkerUrl,
}: AppStandardsInitProps) {
  return (
    <>
      {browserActions ? <BrowserActionsInit /> : null}
      {serviceWorker ? <ServiceWorkerInit serviceWorkerUrl={serviceWorkerUrl} /> : null}
    </>
  );
}
